/* eslint-disable no-undef */
/* eslint-disable import/no-unresolved */
import React from 'react';
/* eslint-disable import/no-unresolved */
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { CommonPopupWithImageComponent } from 'Components/common/commonPopupWithImageComponent';
import { Utils } from 'Utils/utils';

class CommonMsgPopupState {
  @observable showMsgPopup = false;

  defaultPopupValue = {
    title: '',
    description: '',
    btnText: 'Ok',
    customClassName: '',
    customParentClassName: '',
    showCloseBtn: false,
    imgComponent: '',
    actionBtnCallback() {
      console.log('actionBtnCallback');
    },
    clickOutsidePopupCallback() {
      console.log('clickOutsidePopupCallback');
    },
    closeClickCallback() {
      console.log('closeClickCallback');
    },
    showCancelBtn: false,
    cancelBtnText: '',
    cancelBtnCallback() {
      console.log('cancelBtnCallback');
    },
    customParentMaskClass: '',
  };

  @observable popupValues = this.defaultPopupValue;

  @action
  setShowMsgPopup = val => {
    this.showMsgPopup = val;
  };

  @action
  setPopupValues = val => {
    Utils.copyObjectWithoutReference('1 ', this.popupValues);
    this.popupValues = { ...this.popupValues, ...val };
    Utils.copyObjectWithoutReference('2 ', this.popupValues);
  };
}
const commonMsgPopupState = new CommonMsgPopupState();

const CommonMsgPopup = observer(props => {
  const { showMsgPopup, popupValues } = commonMsgPopupState;
  const {
    title,
    description,
    btnText,
    customParentClassName,
    customClassName,
    showCloseBtn,
    imgComponent,
    actionBtnCallback,
    clickOutsidePopupCallback,
    closeClickCallback,
    showCancelBtn,
    cancelBtnText,
    cancelBtnCallback,
    customParentMaskClass,
    svgImgComponent
  } = popupValues;

  return showMsgPopup ? (
    <CommonPopupWithImageComponent
      ImgComponent={imgComponent}
      titleText={title}
      description={description}
      svgImgComponent={svgImgComponent}
      btnText={btnText}
      customParentClass={customParentClassName}
      customClass={customClassName}
      actionBtnCallback={actionBtnCallback}
      clickOutsidePopupCallback={clickOutsidePopupCallback}
      closeClickCallback={closeClickCallback}
      showCloseBtn={showCloseBtn}
      showCancelBtn={showCancelBtn}
      cancelBtnText={cancelBtnText}
      cancelBtnCallback={cancelBtnCallback}
      customParentMaskClass={customParentMaskClass}
    />
  ) : (
    ''
  );
});

export { CommonMsgPopup, commonMsgPopupState };
export default CommonMsgPopup;
